// Copyright (c) Docugami, Inc. All rights reserved.

import { LoggerLevel } from "utils/Logger";

// If you want to develop against the local auth or frontend microservice,
// replace the staging urls with the localhost url for the respective service.

export const dev = {
    baseUrl: "https://localhost:3000",
    auth0: {
        // Try "dev-docugami.us.auth0.com" if the custom domain doesn't work.
        domain: "auth-staging.docugami.com",
        clientId: "fWAo32h0lT4XDQEWqlSPR0oeUfGGcyz9",
        audience: "https://api-staging.docugami.com/",
        scope: "openid profile email offline_access read:workspace write:workspace read:documents write:documents read:builds write:builds read:projects write:projects read:samples"
    },
    signupUrl: "https://www.docugami.com/vip-early-access",
    //apiUrl: "http://localhost:5000",
    apiUrl: "https://api-staging.docugami.com/frontend",
    // dgmlUrl: "http://localhost:5002",
    dgmlUrl: "https://api-staging.docugami.com",
    // organizationApiUrl: "http://localhost:7072/organization",
    organizationApiUrl: "https://api-staging.docugami.com/organization",
    // reportsApiUrl: "http://localhost:7092/reports",
    reportsApiUrl: "https://api-staging.docugami.com/reports",
    // fileManagerApiUrl: "http://localhost:7073/filemanager",
    fileManagerApiUrl: "https://api-staging.docugami.com/filemanager",
    // notificationsApiUrl: "http://localhost:7075/notifications",
    notificationsApiUrl: "https://api-staging.docugami.com/notifications",
    // billingApiUrl: "http://localhost:5287/billing",
    billingApiUrl: "https://api-staging.docugami.com/billing",
    // chatUrl: "http://localhost:9000",
    chatUrl: "https://api-staging.docugami.com/chat-service",
    // repeatsUrl: "http://localhost:5015/repeats",
    repeatsUrl: "https://api-staging.docugami.com/repeats",
    //storageUrl: "http://localhost:5000/storage",
    storageUrl: "https://api-staging.docugami.com/storage",
    contactUsUrl: "https://www.docugami.com/contact-us?hsLang=en",
    dropboxAppKey: "8lnc0py8tcvznq5",
    verboseReduxLogging: true,
    sdvDevMode: true,
    devAlias: "",
    workPaths: {
        saveIntervalMs: 30000
    },
    logger: {
        Default: LoggerLevel.Information
    },
    featureFlags: {
        DiagnosticLoggingEnabled: true,
    },
    appInsights: {
        connectionString: "InstrumentationKey=e7b3f7e0-c4ea-4215-af98-301685691a8d;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=75120975-43c1-49f2-8d6e-344e91ae34d8",
        instrumentationKey: "e7b3f7e0-c4ea-4215-af98-301685691a8d",
        correlationHeaderDomains: ["localhost", "api-staging.docugami.com"]
    },
    idleTimeoutInMinutes: 55,
    idlePromptTimeoutInMinutes: 5,
    chameleonKey: "SNxrr2KpmZBPREpW1M7tgCRj5fqJqdKKoj3CTgt7wHS8XP-1ODfaG-DVwVP6wOpLcLMqRx",
    userbackKey: "8995|16473|qt0e3gwYZvSpoQFvGzpJFqzKdx3FmYNPjoVvMtTc9w6Yx6B8Du",
    googleAnalyticsKey: "G-EMVSHJD3T2",
    apiDocumentationUrl: "https://api-docs-staging.docugami.com",

    // publicApiBaseUrl: "http://localhost:5000/v1preview1",
    publicApiBaseUrl: "https://api-staging.docugami.com/v1preview1",
    zapierClientId: "P03JRqeNJscEyLSG3DnzbqezK2lqC0Pv8GRvcHIP"
}

export const staging = {
    baseUrl: "https://app-staging.docugami.com",
    auth0: {
        // Try "dev-docugami.us.auth0.com" if the custom domain doesn't work.
        domain: "auth-staging.docugami.com",
        clientId: "fWAo32h0lT4XDQEWqlSPR0oeUfGGcyz9",
        audience: "https://api-staging.docugami.com/",
        scope: "openid profile email offline_access read:workspace write:workspace read:documents write:documents read:builds write:builds read:projects write:projects read:samples"
    },
    signupUrl: "https://www.docugami.com/vip-early-access",
    apiUrl: "https://api-staging.docugami.com/frontend",
    dgmlUrl: "https://api-staging.docugami.com",
    organizationApiUrl: "https://api-staging.docugami.com/organization",
    reportsApiUrl: "https://api-staging.docugami.com/reports",
    fileManagerApiUrl: "https://api-staging.docugami.com/filemanager",
    notificationsApiUrl: "https://api-staging.docugami.com/notifications",
    billingApiUrl: "https://api-staging.docugami.com/billing",
    chatUrl: "https://api-staging.docugami.com/chat-service",
    repeatsUrl: "https://api-staging.docugami.com/repeats",
    storageUrl: "https://api-staging.docugami.com/storage",
    contactUsUrl: "https://www.docugami.com/contact-us?hsLang=en",
    dropboxAppKey: "8lnc0py8tcvznq5",
    verboseReduxLogging: true,
    sdvDevMode: false,
    devAlias: "",
    workPaths: {
        saveIntervalMs: 30000
    },
    logger: {
        Default: LoggerLevel.Warning
    },
    featureFlags: {
        DiagnosticLoggingEnabled: true,
    },
    appInsights: {
        connectionString: "",
        instrumentationKey: "",
        correlationHeaderDomains: ["api-staging.docugami.com"]
    },
    idleTimeoutInMinutes: 700,
    idlePromptTimeoutInMinutes: 20,
    chameleonKey: "SNxrr2KpmZBPREpW1M7tgCRj5fqJqdKKoj3CTgt7wHS8XP-1ODfaG-DVwVP6wOpLcLMqRx",
    userbackKey: "8995|16473|qt0e3gwYZvSpoQFvGzpJFqzKdx3FmYNPjoVvMtTc9w6Yx6B8Du",
    googleAnalyticsKey: "G-EMVSHJD3T2",
    apiDocumentationUrl: "https://api-docs-staging.docugami.com",

    publicApiBaseUrl: "https://api-staging.docugami.com/v1preview1",
    zapierClientId: "P03JRqeNJscEyLSG3DnzbqezK2lqC0Pv8GRvcHIP"
}

export const prod = {
    baseUrl: "https://app.docugami.com",
    auth0: {
        // Try "docugami.us.auth0.com" if the custom domain doesn't work.
        domain: "auth.docugami.com",
        clientId: "ed6uEeoc3DmbJfDku70h0n2nT4H0zIhN",
        audience: "https://api.docugami.com/",
        scope: "openid profile email offline_access read:workspace write:workspace read:documents write:documents read:builds write:builds read:projects write:projects read:samples"
    },
    signupUrl: "https://www.docugami.com/vip-early-access",
    apiUrl: "https://api.docugami.com/frontend",
    dgmlUrl: "https://api.docugami.com",
    organizationApiUrl: "https://api.docugami.com/organization",
    reportsApiUrl: "https://api.docugami.com/reports",
    fileManagerApiUrl: "https://api.docugami.com/filemanager",
    notificationsApiUrl: "https://api.docugami.com/notifications",
    billingApiUrl: "https://api.docugami.com/billing",
    chatUrl: "https://api.docugami.com/chat-service",
    repeatsUrl: "https://api.docugami.com/repeats",
    storageUrl: "https://api.docugami.com/storage",
    contactUsUrl: "https://www.docugami.com/contact-us?hsLang=en",
    dropboxAppKey: "32lp25ltf8ee8pj",
    verboseReduxLogging: false,
    sdvDevMode: false,
    devAlias: "",
    workPaths: {
        saveIntervalMs: 30000
    },
    logger: {
        Default: LoggerLevel.Error
    },
    featureFlags: {
    },
    appInsights: {
        connectionString: "",
        instrumentationKey: "",
        correlationHeaderDomains: ["api.docugami.com"]
    },
    idleTimeoutInMinutes: 700,
    idlePromptTimeoutInMinutes: 20,
    chameleonKey: "SNxrr2KpmZBPREpW1M7tgCRj5fqJqdKKoj3CTgt7wHS8XP-1ODfaG-DVwVP6wOpLcLMqRx",
    userbackKey: "8995|16599|qt0e3gwYZvSpoQFvGzpJFqzKdx3FmYNPjoVvMtTc9w6Yx6B8Du",
    googleAnalyticsKey: "G-RRBDQPP02V",
    apiDocumentationUrl: "https://api-docs.docugami.com",

    publicApiBaseUrl: "https://api.docugami.com/v1preview1",
    zapierClientId: "P03JRqeNJscEyLSG3DnzbqezK2lqC0Pv8GRvcHIP"
}

export const Config = process.env.REACT_APP_ENV === "prod" ? prod : process.env.REACT_APP_ENV === "staging" ? staging : dev;
